/* TODO: This lovely grid came from NextGen (https://bitbucket.org/haymarketautomotive/aphrodite-frontend/src/master/)
 * and has been cut down from the original to fit the minimal needs of DRIVE.
 * This will be made a shared component in Olympus and when this is done we should delete this and pull from there.
 */

// @flow
import React, { Component } from 'react';
import classNames from 'classnames';
import styles from '../Grid.scss';
import { getResponsiveClasses } from '../gridFunctions';

/**
 * This is the function callback we pass to the custom proptypes function checker 'checkRelatedProp' used
 * for checking the offset props
 * @param {*} prop - prop to check (xsOffset, smOffset, mdOffset, lgOffset)
 * @param {*} relatedProp - related prop to check (colXs, colSm, colMd, colLg)
 * @return {boolean} -
 */
export const checkSumOffsetAndColCallback = (
  prop: number,
  relatedProp: number
) => {
  return !(prop + relatedProp > 12);
};
/**
 *	Col React presentational component.
 */
class Col extends Component<*, *> {
  /**
   * defaultProps implementation.
   */
  static defaultProps = {
    xsOffset: 0,
    smOffset: 0,
    mdOffset: 0,
    lgOffset: 0
  };

  /**
   *	A props mapping object for offsetting columns.
   * @return {Object}
   *   - An object of prop offset keys and style classes.
   */
  getOffsetClassesMap = () => {
    return {
      xsOffset: 'col-offset-xs',
      smOffset: 'col-offset-sm',
      mdOffset: 'col-offset-md',
      lgOffset: 'col-offset-lg'
    };
  };

  /**
   *	A props mapping object for sizing columns.
   * @return {Object}
   *   - An object of prop size keys and style classes.
   */
  getSizeClassesMap = () => {
    return {
      colXs: 'col-xs',
      colSm: 'col-sm',
      colMd: 'col-md',
      colLg: 'col-lg'
    };
  };

  /**
   * Gets the grid column order classes for each Col.
   * Loops over the order object and returns styles bases on prop keys and values.
   * @return {Array}
   * - An array of style classes to be applied.
   */
  getOrderClasses = () => {
    return Object.keys(this.props.order).map(
      item => styles[`col-order-${item}-${this.props.order[item]}`]
    );
  };

  /**
   * Gets the grid column classes.
   * Loops over all the props then aplly the relavent column classes.
   * @return {Array}
   * - An array of style classes to be applied.
   */
  getColumnClasses = () => {
    const classes = [];

    for (var prop in this.props) {
      switch (prop) {
        // Column size classes.
        case 'colXs':
        case 'colSm':
        case 'colMd':
        case 'colLg':
          // Set column size.
          if (typeof this.props[prop] === 'number') {
            classes.push(
              styles[`${this.getSizeClassesMap()[prop]}-${this.props[prop]}`]
            );
          }
          // Apply hide class. This must go after applied column size.
          if (this.props[prop] === 'hide') {
            classes.push(styles[`${this.getSizeClassesMap()[prop]}-hide`]);
          }
          break;
        // Offset classes.
        case 'xsOffset':
        case 'smOffset':
        case 'mdOffset':
        case 'lgOffset':
          if (this.props[prop] > 0) {
            classes.push(
              styles[`${this.getOffsetClassesMap()[prop]}-${this.props[prop]}`]
            );
          }
          break;
        // AutoWidth classes.
        case 'autoWidth':
          classes.push(
            getResponsiveClasses('col', 'auto', this.props.autoWidth)
          );
          break;
        // Alignment classes.
        case 'start':
        case 'end':
        case 'center':
        case 'baseline':
        case 'stretch':
          classes.push(getResponsiveClasses('col', prop, this.props[prop]));
          break;
        // First and Last class.
        case 'first':
        case 'last':
          classes.push(getResponsiveClasses('col', prop, this.props[prop]));
          break;
      }
    }

    // Order classes.
    if (this.props.order) {
      classes.push(this.getOrderClasses());
    }

    return classes;
  };

  /**
   * Render
   * @return {ReactElement} markup
   */
  render() {
    const columnClasses = this.getColumnClasses();
    const classes = classNames([this.props.className, columnClasses]);

    return (
      <div style={this.props.style} className={classes}>
        {this.props.children}
      </div>
    );
  }
}

export default Col;



// WEBPACK FOOTER //
// ./src/components/Grid/Col/index.js